/* Accessibility repair for the existing StellTails Forms 1058786 embed.
   Adds label associations only; no field values, requests, or submission events. */
(function () {
  'use strict';
  var selector = '[data-forms-id="forms-root-1058786"]';
  var containers = new WeakSet();
  var roots = new WeakSet();

  function repair(root) {
    root.querySelectorAll('textarea[name]').forEach(function (field) {
      var label = Array.from(root.querySelectorAll('label[for]')).find(function (item) {
        return item.htmlFor === field.name && item.textContent.trim();
      });
      if (!label) return;
      if (!field.id && !root.getElementById(field.name)) field.id = field.name;
      if (label.id && !field.hasAttribute('aria-label') && !field.hasAttribute('aria-labelledby')) {
        field.setAttribute('aria-labelledby', label.id);
      }
    });
  }

  function watchHost(host) {
    var root = host.shadowRoot;
    if (!root || roots.has(root)) return;
    roots.add(root);
    repair(root);
    // Child changes cover React remounts, without observing typing or attributes.
    new MutationObserver(function () { repair(root); }).observe(root, { childList: true, subtree: true });
  }

  function start() {
    document.querySelectorAll(selector).forEach(function (container) {
      if (containers.has(container)) return;
      containers.add(container);
      function scan() { container.querySelectorAll('shopify-forms-embed').forEach(watchHost); }
      scan();
      new MutationObserver(scan).observe(container, { childList: true, subtree: true });
    });
  }

  if (window.customElements) customElements.whenDefined('shopify-forms-embed').then(start);
  document.addEventListener('shopify:section:load', start);
})();

/* Keep an enquiry route available when the app's configuration is empty or slow.
   Observes rendering only; never reloads the app, retries requests, or submits. */
(function () {
  'use strict';
  var selector = '[data-st-form-shell]';
  var states = new WeakMap();

  function mount(shell) {
    var existing = states.get(shell);
    if (existing) { existing.scan(); return; }
    var status = shell.querySelector('[data-st-form-status]');
    if (!status) return;
    var ready = false;
    var stopped = false;
    var observedRoots = new WeakSet();
    var observers = [];
    status.textContent = status.dataset.loading;
    var timer = window.setTimeout(function () {
      if (!ready && !stopped) status.textContent = status.dataset.slow;
    }, 12000);

    function scan() {
      if (stopped || ready) return;
      shell.querySelectorAll('shopify-forms-embed').forEach(function (host) {
        var root = host.shadowRoot;
        if (!root) return;
        if (!observedRoots.has(root)) {
          observedRoots.add(root);
          var observer = new MutationObserver(scan);
          observer.observe(root, { childList: true, subtree: true });
          observers.push(observer);
        }
        if (root.querySelector('form input:not([type="hidden"]), form textarea, form select')) {
          ready = true;
          window.clearTimeout(timer);
          status.textContent = status.dataset.ready;
          observers.forEach(function (observer) { observer.disconnect(); });
        }
      });
    }

    var outer = new MutationObserver(scan);
    outer.observe(shell, { childList: true, subtree: true });
    observers.push(outer);
    states.set(shell, {
      scan: scan,
      stop: function () {
        stopped = true;
        window.clearTimeout(timer);
        observers.forEach(function (observer) { observer.disconnect(); });
        states.delete(shell);
      }
    });
    scan();
  }

  function start() { document.querySelectorAll(selector).forEach(mount); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else { start(); }
  if (window.customElements) customElements.whenDefined('shopify-forms-embed').then(start);
  document.addEventListener('shopify:section:load', start);
  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.target.querySelectorAll) return;
    event.target.querySelectorAll(selector).forEach(function (shell) {
      var state = states.get(shell);
      if (state) state.stop();
    });
  });
})();
